import React, { useState, useEffect } from "react";
import FoodService from "../../services/FoodService";

const AddFoodDrinks = () => {
  const initialFoodDrinksState = {
    id: null,
    name: "",
    menucategory_id: "",
    description: "",
    price: "",
    published: false,
  };

  const initialMenucategoryState = {
    id: null,
    name: "",
  };

  const [message, setMessage] = useState("");
  const [menuCategory, setMenuCategory] = useState(initialMenucategoryState);

  const [fooddrinks, setFooddrinks] = useState(initialFoodDrinksState);
  const [submitted, setSubmitted] = useState(false);
  const [servermessage, setServermessage] = useState(
    "You submitted successfully!"
  );
  const [alert, setAlert] = useState("alert alert-danger");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFooddrinks({ ...fooddrinks, [name]: value });
  };

  const handleImageInputChange = (e) => {
    if (e.target.files) {
      const { name, value } = e.target;
      setFooddrinks({ ...fooddrinks, image: [...e.target.files] });
    }
  };
  //  console.log(fooddrinks)

  const getMenucategory = () => {
    FoodService.getAllcategories()
      .then((response) => {
        const newValue = [];
        const datas = response.data;
        // console.log(datas)
        // datas.forEach(data => {
        //   data['image']=JSON.parse(data['image'])

        //   newValue.push(data)
        // });
        setMenuCategory(datas);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const saveFooddrinks = () => {
    var data = {
      name: fooddrinks.name,
      description: fooddrinks.description,
      price: fooddrinks.price,
      menucategory_id: fooddrinks.menucategory_id,
      itemtag: "red",
      chilly: 1,
    };

    FoodService.create(data)
      .then((response) => {
        setFooddrinks({
          id: response.data.id,
          name: response.data.name,
          description: response.data.description,
          price: response.data.price,
          menucategory_id: response.data.menucategory_id,
          published: response.data.published,
        });
        setSubmitted(true);
        setAlert("alert alert-success");
        // console.log(response.data);
      })
      .catch((e) => {
        setSubmitted(true);
        setServermessage("Error: " + e.response.data.message);
        console.log(e);
      });
  };

  const newFooddrinks = () => {
    setFooddrinks(initialFoodDrinksState);
    setSubmitted(false);
  };

  useEffect(() => {
    getMenucategory();
  }, []);

  return (
    <div className="container pb-10">
      <>
        <h1 className="text-1xl lg:text-1xl font-semibold py-10">
          {" "}
          Add Food Or Drinks Item
        </h1>
        <div>
          {submitted ? (
            <div
              className="bg-green-100 border border-green-700 text-clay-500 px-4 py-3 rounded relative"
              role="alert"
            >
              <p style={{ marginBottom: "0" }}>{servermessage}</p>
            </div>
          ) : (
            <>
              <p style={{ marginBottom: "0" }}></p>
            </>
          )}
          <br></br>
        </div>

        <form className="w-full">
          <div className="md:flex md:items-center mb-6">
            <div className="md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                htmlFor="inline-full-name"
              >
                Name
              </label>
            </div>
            <div className="md:w-2/3">
              <input
                className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                type="text"
                id="name"
                required
                value={fooddrinks.name}
                onChange={handleInputChange}
                name="name"
              />
            </div>
          </div>

          <div className="md:flex md:items-center mb-6">
            <div className="md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                htmlFor="inline-password"
              >
                Description
              </label>
            </div>
            <div className="md:w-2/3">
              <textarea
                rows="5"
                className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                id="description"
                name="description"
                type="text"
                value={fooddrinks.description}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="md:flex md:items-center mb-6">
            <div className="md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                htmlFor="inline-password"
              >
                Item Category
              </label>
            </div>
            <div className="md:w-2/3">
              <select
                id="menucategory_id"
                name="menucategory_id"
                type="text"
                className="bg-gray-200  border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                value={fooddrinks.menucategory_id}
                onChange={handleInputChange}
              >
                <option value="">---</option>

                {menuCategory?.length > 0 &&
                  menuCategory.map((item, index) => (
                    <option
                      value={item.id}
                      key={index}
                    >
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="md:flex md:items-center mb-6">
            <div className="md:w-1/3">
              <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">
                Price $
              </label>
            </div>
            <div className="md:w-2/3">
              <input
                className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                id="price"
                name="price"
                type="text"
                value={fooddrinks.price}
                required
                onChange={handleInputChange}
              />
            </div>
          </div>
        </form>

        <div className="md:flex md:items-center">
          <div className="md:w-1/3"></div>
          <div className="md:w-2/3 grid grid-cols-2 gap-40">
            {submitted ? (
              <div>
                {/* <div classNameName={alert} role="alert">
          {servermessage}
</div> */}

                <button
                  className="shadow bg-green-800 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                  type="submit"
                  onClick={newFooddrinks}
                >
                  Add New
                </button>
              </div>
            ) : (
              <>
                <button
                  className="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                  type="submit"
                  onClick={saveFooddrinks}
                >
                  Submit
                </button>
              </>
            )}
          </div>
        </div>
      </>
    </div>
  );
};
export default AddFoodDrinks;
